<form [formGroup]="form" class="searchForm">
    <nz-row>
        <nz-col [nzSpan]="8">
            <nz-form-item>
                <nz-form-label [nzFlex]="size.label">
                    {{'Common.Keyword' | translate }}
                </nz-form-label>
                <nz-form-control [nzFlex]="size.control">
                    <input nz-input formControlName="keyword" placeholder="请输入要查询的关键字" nzSize="normal">
                </nz-form-control>
            </nz-form-item>
        </nz-col>
        <nz-col>
            <button type="submit" nz-button nzType="primary" (click)="search()"><i nz-icon nzType="search"></i>{{'Common.Query' | translate }}</button>
            <button type="button" nz-button (click)="new()" authorize="Configuration.Code.Add"><i nz-icon nzType="plus"></i>{{'Common.Add' | translate }} {{categoryName}}</button>
            <button type="reset" nz-button><i nz-icon nzType="undo"></i>{{'Common.Reset' | translate }}</button>
        </nz-col>
    </nz-row>

</form>

<nz-table #table [pagedData]="queryResult$ | async" [nzFrontPagination]="false"  (nzPageIndexChange)="onPageIndexChagne($event)" [nzShowTotal]="rangeTemplate" nzTableLayout="fixed">
    <thead>
        <tr>
            <th>{{'Common.Name' | translate }}</th>
            <th>{{'Common.Type' | translate }}</th>
            <th>{{'Common.Description' | translate }}</th>
            <th>{{'Common.Action' | translate }}</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let item of tableData">
            <td>{{item.localizedName}}</td>
            <td>
                {{ 'Common.DataTypes.'+item.dataType  | translate }}
            </td>
            <td nzEllipsis nz-tooltip [nzTooltipTitle]="item.description">{{item.description}}</td>
            <td style="min-width: 100px;">
                <button (click)="edit(item)" nz-button nzType="link" [nzTooltipTitle]="'Common.Edit' | translate" nz-tooltip authorize="Configuration.Code.Edit">
                    <i nz-icon nzType="edit" ></i>
                </button>
                <wx-delete-confirm-icon (confirm)="delete(item)" authorize="Configuration.Code.Delete"></wx-delete-confirm-icon>
            </td>
        </tr>
    </tbody>
</nz-table>
<ng-template #rangeTemplate  let-total> {{'Common.Total' | translate }} {{ total }} {{'Common.Item' | translate }} </ng-template>